import { render, staticRenderFns } from "./plaintext.vue?vue&type=template&id=f1f328ac&scoped=true&"
import script from "./plaintext.vue?vue&type=script&lang=js&"
export * from "./plaintext.vue?vue&type=script&lang=js&"
import style0 from "./plaintext.vue?vue&type=style&index=0&id=f1f328ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f328ac",
  null
  
)

export default component.exports